/* Skin Win — cart drawer enhancements:
   1. Free-shipping progress bar ($55 threshold)
   2. Under-threshold upsell (Pore No More Toner, $15) with one-tap add
   3. Hero-video autoplay nudge for mobile browsers
   Local master copy — deployed as assets/skinwin-cart-progress.js */
(function () {
  var THRESHOLD = 5500; // cents
  var UPSELL = {
    variantId: 46062087667889,
    title: 'Pore No More Toner',
    priceLabel: '$15, gets you closer to free shipping',
    image: 'https://cdn.shopify.com/s/files/1/0591/2022/2385/files/Pore_No_More_toner.jpg?v=1767782111&width=120',
    url: '/products/pore-refining-toner'
  };
  var lastTotal = null;
  var cartVariantIds = [];
  var updating = false;
  var t;

  function ensureStyles() {
    if (document.getElementById('sw-ship-css')) return;
    var s = document.createElement('style');
    s.id = 'sw-ship-css';
    s.textContent = '.sw-ship{padding:16px 20px 14px;border-bottom:1px solid rgba(28,27,26,.12)}' +
      '.sw-ship__msg{font-family:var(--font-accent--family,Inter,sans-serif);font-size:12.5px;margin:0 0 10px;color:var(--color-foreground,#1C1B1A)}' +
      '.sw-ship__msg b{color:#2A8A92;font-weight:700}' +
      '.sw-ship__bar{height:5px;background:rgba(28,27,26,.12);border-radius:10px;overflow:hidden}' +
      '.sw-ship__fill{height:100%;width:0%;background:#2A8A92;border-radius:10px;transition:width .5s cubic-bezier(.16,1,.3,1)}' +
      '.sw-upsell{display:flex;align-items:center;gap:12px;background:#FFFFFF;margin:12px 20px 0;padding:12px;font-family:var(--font-accent--family,Inter,sans-serif);font-size:12.5px;color:#1C1B1A}' +
      '.sw-upsell img{width:48px;height:48px;object-fit:cover;flex-shrink:0}' +
      '.sw-upsell__txt b{display:block;font-size:13px}' +
      '.sw-upsell__txt span{color:#57534E;font-size:11.5px}' +
      '.sw-upsell__btn{margin-left:auto;background:none;border:1px solid #1C1B1A;color:#1C1B1A;padding:8px 14px;font-family:inherit;font-size:10px;letter-spacing:.14em;text-transform:uppercase;font-weight:700;cursor:pointer;white-space:nowrap;transition:all .3s}' +
      '.sw-upsell__btn:hover{background:#1C1B1A;color:#FFEBD5}' +
      '.sw-upsell__btn[disabled]{opacity:.6;cursor:default}' +
      '.sw-trust-strip{font-family:var(--font-accent--family,Inter,sans-serif);font-size:12px;color:#57534E;line-height:1.8;margin:14px 0 0}';
    document.head.appendChild(s);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function render(total) {
    var inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return;
    updating = true;
    try {
      var bar = inner.querySelector('.sw-ship');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'sw-ship';
        bar.innerHTML = '<p class="sw-ship__msg"></p><div class="sw-ship__bar"><div class="sw-ship__fill"></div></div>';
        inner.insertBefore(bar, inner.firstChild);
      }
      if (total <= 0) {
        bar.style.display = 'none';
      } else {
        bar.style.display = '';
        var pct = Math.min(100, (total / THRESHOLD) * 100);
        bar.querySelector('.sw-ship__fill').style.width = pct + '%';
        var msg = bar.querySelector('.sw-ship__msg');
        msg.innerHTML = total >= THRESHOLD
          ? '<b>✓ Free U.S. shipping unlocked</b>'
          : 'You’re <b>' + money(THRESHOLD - total) + '</b> away from free U.S. shipping';
      }
      renderUpsell(inner, bar, total);
      lastTotal = total;
    } finally {
      setTimeout(function () { updating = false; }, 0);
    }
  }

  function renderUpsell(inner, bar, total) {
    var up = inner.querySelector('.sw-upsell');
    var shouldShow = total > 0 && total < THRESHOLD && cartVariantIds.indexOf(UPSELL.variantId) === -1;
    if (!shouldShow) {
      if (up) up.remove();
      return;
    }
    if (!up) {
      up = document.createElement('div');
      up.className = 'sw-upsell';
      up.innerHTML = '<img src="' + UPSELL.image + '" alt="' + UPSELL.title + '">' +
        '<div class="sw-upsell__txt"><b>' + UPSELL.title + '</b><span>' + UPSELL.priceLabel + '</span></div>' +
        '<button type="button" class="sw-upsell__btn">Add</button>';
      up.querySelector('.sw-upsell__btn').addEventListener('click', addUpsell);
      bar.insertAdjacentElement('afterend', up);
    }
  }

  function addUpsell(e) {
    var btn = e.currentTarget;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: UPSELL.variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added';
        refreshDrawerItems();
        refresh(true);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  }

  /* Re-fetch the page and swap in the fresh cart item list so the drawer
     reflects AJAX adds without a reload. Our injected elements are preserved. */
  function refreshDrawerItems() {
    fetch(window.location.href, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshItems = doc.querySelector('.cart-drawer__inner cart-items-component');
        var currentItems = document.querySelector('.cart-drawer__inner cart-items-component');
        if (freshItems && currentItems) {
          updating = true;
          currentItems.replaceWith(freshItems);
          setTimeout(function () { updating = false; }, 0);
        }
        var freshBubble = doc.querySelector('header-component .cart-bubble, [class*="cart-bubble"]');
        var currentBubble = document.querySelector('header-component .cart-bubble, [class*="cart-bubble"]');
        if (freshBubble && currentBubble) currentBubble.replaceWith(freshBubble);
      })
      .catch(function () {});
  }

  function refresh(force) {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          cartVariantIds = (c.items || []).map(function (i) { return i.variant_id; });
          var mustInsert = !document.querySelector('.cart-drawer__inner .sw-ship');
          if (force || mustInsert || c.total_price !== lastTotal) render(c.total_price);
        })
        .catch(function () {});
    }, 150);
  }

  function observe() {
    var comp = document.querySelector('cart-drawer-component');
    if (!comp) return;
    new MutationObserver(function (muts) {
      if (updating) return;
      var force = muts.some(function (m) { return m.type === 'attributes'; });
      refresh(force);
    }).observe(comp, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
  }

  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (el && el.closest && el.closest('cart-drawer-component')) refresh(true);
  }, true);

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { refresh(true); });
    }
    return p;
  };

  /* ---- Hero video autoplay nudge ----
     Mobile browsers (especially iOS, and always in Low Power Mode) can block
     the initial autoplay. Retry on load, shortly after, and on first touch. */
  function nudgeVideos() {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      if (v.paused) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }

  /* ---- Product-page trust strip under the buy buttons ---- */
  function insertTrustStrip() {
    var main = document.querySelector('main[data-template*="product"]');
    if (!main || document.querySelector('.sw-trust-strip')) return;
    var form = main.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var wrap = form.closest('buy-buttons, product-form-component, [class*="buy-buttons"]') || form;
    var strip = document.createElement('p');
    strip.className = 'sw-trust-strip';
    strip.innerHTML = '✓ Free U.S. shipping $55+ &nbsp;·&nbsp; Small-batch handcrafted &nbsp;·&nbsp; Vegan + cruelty-free';
    wrap.insertAdjacentElement('afterend', strip);
  }

  function init() {
    ensureStyles();
    observe();
    refresh(true);
    nudgeVideos();
    insertTrustStrip();
    setTimeout(function () { nudgeVideos(); insertTrustStrip(); }, 1500);
  }

  window.addEventListener('load', nudgeVideos);
  document.addEventListener('touchstart', nudgeVideos, { once: true, passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
